"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playerNeedsMissingEntityRedirect = playerNeedsMissingEntityRedirect;
exports.resolveSafeMissingEntityReturnScene = resolveSafeMissingEntityReturnScene;
exports.warnUnknownEntityTypeIds = warnUnknownEntityTypeIds;
const constants_1 = require("./constants");
function getAdventureScene(adventure, sceneId) {
    if (!adventure?.scenes) {
        return undefined;
    }
    return adventure.scenes.find(s => s.id === sceneId);
}
/**
 * True when the player is on an entity-dependent scene without a valid current entity.
 * Does not redirect by itself — callers navigate / persist.
 */
function playerNeedsMissingEntityRedirect(adventure, sceneId, currentEntityId, entityExists) {
    if (!adventure || !sceneId) {
        return false;
    }
    const id = String(sceneId).trim();
    if (!id || id === constants_1.MISSING_ENTITY_SCENE_ID) {
        return false;
    }
    const scene = getAdventureScene(adventure, id);
    const dependentFromList = Array.isArray(adventure.entityDependentSceneIds)
        ? adventure.entityDependentSceneIds.includes(id)
        : false;
    const isDependent = dependentFromList || !!scene?.requiresCurrentEntity;
    if (!isDependent) {
        return false;
    }
    const entityId = String(currentEntityId ?? '').trim();
    if (!entityId) {
        return true;
    }
    return !entityExists(entityId);
}
/**
 * Prefer a non–entity-dependent scene from `preferredIds` (e.g. return stack), else fallback.
 */
function resolveSafeMissingEntityReturnScene(adventure, preferredSceneIds, fallbackSceneId = constants_1.MISSING_ENTITY_FALLBACK_SCENE_ID) {
    if (adventure) {
        for (const raw of preferredSceneIds) {
            const id = String(raw ?? '').trim();
            if (!id || id === constants_1.MISSING_ENTITY_SCENE_ID) {
                continue;
            }
            const scene = getAdventureScene(adventure, id);
            if (!scene) {
                continue;
            }
            const dependentFromList = Array.isArray(adventure.entityDependentSceneIds)
                ? adventure.entityDependentSceneIds.includes(id)
                : false;
            if (dependentFromList || scene.requiresCurrentEntity) {
                continue;
            }
            return id;
        }
        if (getAdventureScene(adventure, fallbackSceneId)) {
            return fallbackSceneId;
        }
    }
    return fallbackSceneId;
}
/** Log once per unknown type id when instances reference removed adventure types. */
function warnUnknownEntityTypeIds(instances, knownTypeIds, contextLabel) {
    const unknown = new Set();
    for (const inst of instances) {
        const typeId = String(inst.typeId ?? '').trim();
        if (typeId && !knownTypeIds.has(typeId)) {
            unknown.add(typeId);
        }
    }
    if (unknown.size === 0) {
        return;
    }
    console.warn(`[entities] ${contextLabel}: ${unknown.size} unknown entity type id(s) ` +
        `(${[...unknown].sort().join(', ')}). Instances are hidden from Entity-List but can still be destroyed.`);
}
//# sourceMappingURL=missingEntityRedirect.js.map